import { Stack, Typography } from '@mui/material';
import { CaseMessageModel } from '../../../lib/models/CaseMessageModel';

type CaseMessagesProps = {
    data: CaseMessageModel[] | null;
};

const MessageList = ({ data }: CaseMessagesProps) => {
    return (
        <>
            {data?.map((value, index) => {
                return (
                    <Stack key={index}>
                        <Typography variant="h3" sx={{ marginBottom: 0.5, fontSize: '1rem' }}>
                            {value.createdBy}
                        </Typography>
                        <Typography
                            variant="h4"
                            sx={{
                                marginBottom: 0.5
                            }}>{`${value.displayCreatedDate} | ${value.displayCreatedTime} EST`}</Typography>
                        <Typography
                            variant="h6"
                            sx={{ marginBottom: 2, fontSize: '0.938rem', whiteSpace: 'pre-line' }}>
                            {value.text}
                        </Typography>
                    </Stack>
                );
            })}
        </>
    );
};

export default MessageList;
